import { Component, JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { TooltipPlacement } from "@app/shared/literals";
import TooltipWrapper from "@app/shared/TooltipWrapper";

interface InfoIndicatorProps {
  /** [Optional] Apply custom css class to indicator icon  */
  className?: string;
  /** [Optional] Where to place the tooltip. 'Default: auto' */
  tooltipPlacement?: TooltipPlacement;
  /** [Optional] The width of the tooltop. 'Default: auto' */
  tooltipWidth?: string;
  /**
   * [Optional] Extra class applied to the portaled tooltip body (not the Ⓘ icon). Use when this
   * indicator is rendered inside a modal — see TooltipWrapper's tooltipBodyClassName for why the
   * default z-index isn't enough there.
   */
  tooltipBodyClassName?: string;
  /** The informational tooltip to be displayed */
  tooltipTitle: string | JSX.Element;
}

/** A standardized way to communicate additional to the user. Renders the Ⓘ with a stylized informational tooltip */
export default class InfoIndicator extends Component<InfoIndicatorProps> {
  public render() {
    return (
      <TooltipWrapper text={this.props.tooltipTitle} position={this.props.tooltipPlacement} tooltipWidth={this.props.tooltipWidth} tooltipBodyClassName={this.props.tooltipBodyClassName}>
        <div className={this.props.className}>
          <QesIcon iconName={QesIcons.InfoCircle} description={"Info"} />
        </div>
      </TooltipWrapper>
    );
  }
}
